module.exports = __webpack_public_path__ + "static/img/Adobe-PDF-Document-icon.b0fa2b19.png";